module.exports = __webpack_public_path__ + "static/media/preview_pdf.f068612b.jpg";